import { render, staticRenderFns } from "./ApprovalStatus.vue?vue&type=template&id=512e22fa&scoped=true&"
import script from "./ApprovalStatus.vue?vue&type=script&lang=js&"
export * from "./ApprovalStatus.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalStatus.vue?vue&type=style&index=0&id=512e22fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e22fa",
  null
  
)

export default component.exports